import { setDefaultOptions } from 'date-fns';
import { enUS, sv } from 'date-fns/locale';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import legacyEnLocales from 'src/legacy/locales/langs/en';
import legacySeLocales from 'src/legacy/locales/langs/se';

import { accountingI18n } from './accounting/i18n';
import { aiI18n } from './ai/i18n';
import { arrangementI18n } from './arrangement/i18n';
import { careI18n } from './care/i18n';
import { deviationI18n } from './deviation/i18n';
import { implementationI18n } from './implementation/i18n';
import { organizationI18n } from './organization/i18n';
import { sharedI18n } from './shared/i18n';
import { vaultI18n } from './vault/i18n';

i18n.on('languageChanged', (lng) => {
  const locale = { en: enUS, 'sv-SE': sv }[lng];

  if (!locale) {
    setDefaultOptions({ locale: enUS });
  } else {
    setDefaultOptions({ locale });
  }
});

type FeatureI18n = Record<
  string,
  Record<SupportedLanguages, Record<string, unknown>>
>;

type SupportedLanguages = 'en' | 'sv-SE';

const legacyI18n: FeatureI18n = {
  translations: { en: legacyEnLocales, 'sv-SE': legacySeLocales },
};

const translations: FeatureI18n[] = [
  legacyI18n,
  deviationI18n,
  sharedI18n,
  vaultI18n,
  organizationI18n,
  careI18n,
  arrangementI18n,
  implementationI18n,
  aiI18n,
  accountingI18n,
];
const namespaces = translations.map((t) => Object.keys(t)[0]);

type Resources = Record<SupportedLanguages, Record<string, object | string>>;

const resources: Resources = {
  en: {},
  'sv-SE': {},
};

translations.forEach((feature) => {
  Object.keys(feature).forEach((namespace) => {
    Object.keys(feature[namespace]).forEach((lang) => {
      const lng = lang as SupportedLanguages;
      resources[lng][namespace] = feature[namespace][lng];
    });
  });
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    defaultNS: namespaces[0],
    fallbackLng: 'sv-SE',
    interpolation: {
      escapeValue: false,
    },
    ns: namespaces,
    resources,
  });

export default i18n;
